// extracted by mini-css-extract-plugin
module.exports = {"list":"_3IdMd","link":"_2RD1V","date":"_2vhPo","bordered":"KE0E-","selected":"_21mCi"};